<div>
    <app-tool-bar [title]="'Manage Campaign'" [iconName]="'pi-megaphone'" [isSearch]="true" [isAdd]="true"
        [filtersOptions]="filtersOptions" (handleAdd)="handleAddCampaign()"
        (search)="handleSearch($event)"></app-tool-bar>
</div>


<div class="p-4 overflow-hidden h-[85vh] flex flex-col">
    <div class="tab-container mb-2">

        <div *ngFor="let tab of tabs" class="outer-tab flex items-center" [ngClass]="{ 'active': active === tab.value,
        'inactive': active !== tab.value
       }" (click)="setActiveTab(tab.value)">
            <div class="tab">

                <img style="height :25px; width: 25px;" *ngIf="tab.value == 'whatsapp'" [src]="tab.icon" alt="icon"
                    class="icon">
                <i *ngIf="tab.icon == 'email'" class="pi pi-envelope"
                    style="font-size: 19px;color: #1b6281; font-weight: 600;"></i>
                <i *ngIf="tab.icon == 'call'" class="pi pi-phone"
                    style="font-size: 19px;color: #14c017; font-weight: 600;"></i>
                {{ tab.label }}

            </div>

        </div>

    </div>

    <div [ngClass]="active === 'call' ? 'flex gap-4' : 'flex flex-col'" class="h-full flex-1 min-h-0">
        <div [ngClass]="active === 'call' ? (isMinimized ? 'w-[95%]' : 'w-[75%]') : 'w-full flex-1'"
            class="overflow-y-auto min-h-0" style="transition: width 0.3s ease;">
            <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
                (onLazyLoad)="loadData($event)" [loading]="loading" [styleClass]="'p-datatable-striped'"
                [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [globalFilterFields]="['campaign_name', 'status']">
                <ng-template pTemplate="header">
                    <tr class="table-header-row">
                        <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''"
                            [ngClass]="{'s-no-column': col.type === 'sno', 'action-column': col.type === 'action'}">
                            <div class="header-content">
                                {{ col.header }}
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
                    <tr class="data-row" [ngClass]="{'even-row': i % 2 === 0, 'odd-row': i % 2 === 1}">
                        <td *ngFor="let col of displayedColumns"
                            [ngClass]="{'s-no-column': col.type === 'sno', 'action-column': col.type === 'action'}">
                            <ng-container [ngSwitch]="col.type">
                                <!-- Handle S.No Column -->
                                <ng-container *ngSwitchCase="'sno'">
                                    <span class="sno-badge">{{ i + 1 }}</span>
                                </ng-container>
                                <!-- Handle Actions -->
                                <ng-container *ngSwitchCase="'action'">
                                    <div *ngIf="!loading" (click)="setTemplateEditData(rowData)" class="flex justify-center">
                                        <div
                                            *ngIf="active == 'call' && rowData.status != 'Completed' && rowData.status != 'Processing' && rowData.status != 'Schedule'">
                                            <p-menu [tabindex]="undefined" #menu [model]="callActionItems"
                                                [popup]="true" appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>

                                        <div *ngIf="active == 'call' && rowData.status == 'Schedule'">
                                            <p-menu [tabindex]="undefined" #menu [model]="scheduleCallActionItems"
                                                [popup]="true" appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>

                                        <div
                                            *ngIf="active == 'call' && (rowData.status == 'Completed' || rowData.status == 'Processing')">
                                            <p-menu [tabindex]="undefined" #menu [model]="completedCallActionItems"
                                                [popup]="true" appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>

                                        <div
                                            *ngIf="active != 'call' && rowData.status != 'Completed' && rowData.status != 'Processing' && rowData.status != 'Schedule'">
                                            <p-menu [tabindex]="undefined" #menu [model]="actionItems" [popup]="true"
                                                appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>

                                        <div *ngIf="active != 'call' && rowData.status == 'Schedule'">
                                            <p-menu [tabindex]="undefined" #menu
                                                [model]="scheduleEmailWhatsappActionItems" [popup]="true"
                                                appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>

                                        <div
                                            *ngIf="active != 'call' && (rowData.status == 'Completed' || rowData.status == 'Processing')">
                                            <p-menu [tabindex]="undefined" #menu
                                                [model]="completedEmailWhatsappActionItems" [popup]="true"
                                                appendTo="body"></p-menu>
                                            <button (click)="menu.toggle($event)" 
                                                class="inline-flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 ease-in-out bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer">
                                                <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                            </button>
                                        </div>
                                    </div>


                                </ng-container>

                                <ng-container *ngSwitchCase="'status'">
                                    <div class="status-chip" [ngStyle]="getStatusStyle(rowData[col.field])">
                                        <i [ngClass]="getStatusIcon(rowData[col.field])" class="status-icon"></i>
                                        {{ rowData[col.field] }}
                                    </div>
                                </ng-container>



                                <ng-container *ngSwitchCase="'contact_group'">
                                    {{ rowData[col.field]?.name || 'Group No Longer Exists' }}
                                </ng-container>

                                <ng-container *ngSwitchCase="'date'">
                                    <ng-container *ngIf="col.field === 'schedule_date'">
                                        {{ formatScheduleDateInIST(rowData[col.field]) }}
                                    </ng-container>
                                    <ng-container *ngIf="col.field !== 'schedule_date'">
                                        {{ rowData[col.field] ? (rowData[col.field] | date: 'dd/MM/yyyy') : 'N/A' }}
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngSwitchCase="'time'">
                                    {{ rowData[col.field] ? (rowData[col.field]) : 'N/A' }}
                                </ng-container>

                                <ng-container *ngSwitchCase="'is_schedule'">
                                    {{ rowData[col.field] ? 'Yes' : 'No' }}
                                </ng-container>

                                <ng-container *ngSwitchCase="'additional_details'">
                                    <div>
                                        {{ rowData['additional_details'] ? rowData['additional_details'][col.field] ||
                                        'N/A'
                                        : 'N/A' }}
                                    </div>
                                </ng-container>

                                <!-- Default Case (Normal Field) -->
                                <ng-container *ngSwitchDefault>
                                    {{ rowData[col.field] || 'N/A' }}
                                </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loading">
                    <tr>
                        <td colspan="3" class="text-center">
                            <p-progressSpinner></p-progressSpinner>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="displayedColumns.length + 1" class="no-data">
                            <p>No records found</p>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Email Metrics Bottom Bar (Only in Email Tab) - Sticky at Bottom -->
        <div *ngIf="active === 'email'" class="sticky bottom-0 bg-white border-t border-gray-200 shadow-lg z-30" style="  width: 99.5%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #ffffff;
    margin-top: 7px;">
            <div class="px-4 py-2 flex items-center justify-between gap-4 flex-wrap">
                <!-- Left: Email Info -->
                <div class="flex items-center gap-2 flex-1 min-w-0">
                    <i class="pi pi-envelope text-blue-500 text-lg shrink-0"></i>
                    <div class="min-w-0 flex-1">
                        <p *ngIf="assignedEmailForMarketing" class="text-xs font-semibold text-gray-800 truncate">
                            {{ assignedEmailForMarketing }}
                        </p>
                        <p *ngIf="!assignedEmailForMarketing" class="text-xs text-gray-400 italic">
                            No email configured
                        </p>
                    </div>
                </div>

                <!-- Center: Metrics (if email data exists) -->
                <div *ngIf="assignedEmailData && assignedEmailData.reputation"
                    class="flex items-center gap-4 flex-wrap">
                    <!-- Reputation Score -->
                    <div class="flex flex-col items-center gap-0.5">
                        <span class="text-xs text-gray-500 font-medium">Reputation</span>
                        <span
                            class="inline-flex items-center justify-center text-xs font-bold px-1.5 py-0.5 rounded border"
                            [ngClass]="{
                                'bg-green-100 text-green-700 border-green-400': assignedEmailData.reputation.final_reputation_score >= 80,
                                'bg-yellow-100 text-yellow-700 border-yellow-400': assignedEmailData.reputation.final_reputation_score >= 60 && assignedEmailData.reputation.final_reputation_score < 80,
                                'bg-red-100 text-red-700 border-red-400': assignedEmailData.reputation.final_reputation_score < 60
                            }">
                            {{ assignedEmailData.reputation.final_reputation_score || '—' }}
                        </span>
                    </div>

                    <!-- Click Rate -->
                    <div class="flex flex-col items-center gap-0.5">
                        <span class="text-xs text-gray-500 font-medium">Click</span>
                        <span class="text-xs font-semibold text-indigo-600">
                            {{ assignedEmailData.reputation.click_rate || '—' }}%
                        </span>
                    </div>

                    <!-- Open Rate -->
                    <div class="flex flex-col items-center gap-0.5">
                        <span class="text-xs text-gray-500 font-medium">Open</span>
                        <span class="text-xs font-semibold"
                            [ngClass]="assignedEmailData.reputation.open_rate >= 30 ? 'text-green-600' : 'text-orange-500'">
                            {{ assignedEmailData.reputation.open_rate || '—' }}%
                        </span>
                    </div>

                    <!-- Bounce Rate -->
                    <div class="flex flex-col items-center gap-0.5">
                        <span class="text-xs text-gray-500 font-medium">Bounce</span>
                        <span class="text-xs font-semibold"
                            [ngClass]="assignedEmailData.reputation.bounce_rate > 2 ? 'text-red-600' : 'text-green-600'">
                            {{ assignedEmailData.reputation.bounce_rate || '—' }}%
                        </span>
                    </div>

                    <!-- Daily Limit -->
                    <div class="flex flex-col items-center gap-0.5" *ngIf="assignedEmailData.daily_limit">
                        <span class="text-xs text-gray-500 font-medium">Today's Limit</span>
                        <span class="text-xs font-semibold text-purple-700">
                            {{ assignedEmailData?.daily_used_count | number}}/{{ assignedEmailData.daily_limit | number
                            }}
                        </span>
                    </div>
                </div>

                <!-- Right: Connect Email Button (if no email) -->
                <div *ngIf="!assignedEmailForMarketing" class="shrink-0">
                    <button pButton type="button" label="Configure" icon="pi pi-cog"
                        class="p-button-sm p-button-primary" (click)="navigateToConfiguration()">
                    </button>
                </div>

                <!-- Right: Loading state -->
                <div *ngIf="emailMetricsLoading" class="shrink-0">
                    <p-progressSpinner [style]="{ width: '20px', height: '20px' }" strokeWidth="4"></p-progressSpinner>
                </div>
            </div>
        </div>

        <!-- Draggable iframe for call tab -->
        <div *ngIf="active === 'call'" [ngClass]="isMinimized ? 'w-[2%]' : 'w-[25%]'"
            class="relative overflow-y-auto min-h-0" style="transition: width 0.3s ease; min-width: fit-content;">
            <div class="sip-dialer-container" [class.minimized]="isMinimized" cdkDrag [cdkDragBoundary]="'.p-4'">
                <div class="sip-dialer-header" cdkDragHandle>
                    <span class="sip-dialer-title" *ngIf="!isMinimized">Dialer</span>
                    <button class="sip-minimize-btn" (click)="toggleMinimize()">
                        <i [class]="isMinimized ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'"></i>
                    </button>
                </div>
                <div class="sip-dialer-content" *ngIf="!isMinimized">
                    <iframe [src]="sipDialerUrl" frameborder="0" class="sip-iframe" allow="microphone"
                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals">
                    </iframe>
                </div>
            </div>
        </div>
    </div>

</div>


<p-dialog [modal]="true" [(visible)]="isAddCampaign" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isAddCampaign">
        <app-add-campaign (closeDialog)="isAddCampaign = false" [emailTemplates]="emailTemplates" [active]="active"
            [whatsappTemplates]="whatsappTemplates" [contactGroups]="contactGroups"
            (reload)="reloadDataTable()"></app-add-campaign>
    </div>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isEditCampaign" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isEditCampaign">
        <app-add-campaign (closeDialog)="isEditCampaign = false" [emailTemplates]="emailTemplates" [type]="'Update'"
            [active]="active" [campaignData]="editData" [whatsappTemplates]="whatsappTemplates"
            [contactGroups]="contactGroups" (reload)="reloadDataTable()"></app-add-campaign>
    </div>
</p-dialog>


<!-- // run campaign -->

<p-dialog [modal]="true" [(visible)]="isRunCampaign" [breakpoints]="{ '1199px': '70vw', '600px': '90vw' }"
    closable="false" [style]="{ width: active == 'whatsapp' ? '30vw' : '70vw'}" [draggable]="false" [resizable]="false">
    <div *ngIf="isRunCampaign">
        <div class="flex items-center justify-center dialog-header ">
            Run Campaign
            <div class="absolute right-2">
                <button (click)="isRunCampaign = false" class="outline-none p-5">
                    <i class="pi pi-times"></i>
                </button>
            </div>

        </div>

        <div class="dialog-content">
            <div class="modal-body">

                <div *ngIf="active === 'whatsapp'">
                    <div class="spinner" *ngIf="isFetchingTemplates">
                        <img src="assets/loader.gif" alt="Loading...">
                    </div>

                    <div *ngIf="!isFetchingTemplates">
                        <app-preview-whatsapp-template [showHeader]="false" [showDilogContentClass]="false"
                            [templateDataToEdit]="whatsappPreviewTemplate"></app-preview-whatsapp-template>
                    </div>
                </div>

                <div *ngIf="active === 'email'">
                    <div class="spinner" *ngIf="isFetchingTemplates">
                        <img src="assets/loader.gif" alt="Loading...">
                    </div>

                    <div *ngIf="!isFetchingTemplates" style="margin-bottom: 20px;">
                        <app-preview-email-template [processedData]="processedData" [showHeader]="false"
                            [type]="'campaign'" [documents]="emailTemplateDocuments"></app-preview-email-template>

                    </div>
                </div>

                <p class="text-center mt-2" style="font-size: 16px; padding: 0px 6px;">Are you sure you want to run
                    campaign:
                    <span style="font-weight: 600;">{{this.editData.campaign_name}}</span>
                    ?
                </p>

                <div class="flex justify-end mt-5">
                    <p-button label="close" class="mr-2" variant="outlined" severity="danger"
                        (click)="isRunCampaign = false"></p-button>
                    <p-button label="Run Campaign" icon="pi pi-send" [loading]="btnLoading" [disabled]="btnLoading"
                        (click)="runCampaign()"></p-button>
                </div>
            </div>
        </div>

    </div>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteCampaign" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        Delete Template

        <div class="absolute right-2">
            <button (click)="isDeleteCampaign = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="mt-2 mb-2" style="font-weight: 500; font-size: 17px; text-align: center;">
            Are you sure you want to delete this campaign : {{this.editData.campaign_name}} ?
        </div>

        <div class="flex gap-4 mt-7 justify-end">

            <p-button label="Cancel" severity="danger" variant="outlined" (click)="isDeleteCampaign = false"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="deleteCampaign()"
                [disabled]="btnLoading" [loading]="btnLoading">
            </p-button>


        </div>

    </div>

</p-dialog>



<p-dialog [modal]="true" [(visible)]="openTestCallDialog" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="openTestCallDialog">
        <app-test-call [campData]="editData" (closeDialog)="openTestCallDialog = false"></app-test-call>
    </div>
</p-dialog>

<!-- Test WhatsApp Campaign Dialog -->
<p-dialog [modal]="true" [(visible)]="openTestWhatsappDialog" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [contentStyle]="{ 'overflow': 'visible' }" [draggable]="false"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-2">
            <i class="pi pi-flask text-2xl text-blue-600"></i>
            <span class="font-bold text-xl">Test WhatsApp Campaign</span>
        </div>
    </ng-template>
    <div class="flex flex-col gap-4 p-4" style="overflow: visible;">
        <div class="flex flex-col gap-2">
            <label for="testPhone" class="font-semibold text-gray-700">Phone Number</label>
            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="['in']" [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true" [searchCountryFlag]="true" [selectFirstCountry]="true"
                [(ngModel)]="testPhoneNumber" [maxLength]="15" name="testPhone">
            </ngx-intl-tel-input>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" [text]="true"
                (onClick)="openTestWhatsappDialog = false; testPhoneNumber = ''">
            </p-button>
            <p-button label="Send Test" icon="pi pi-send" [loading]="btnLoading" (onClick)="testWhatsappCampaign()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Test Email Campaign Dialog -->
<p-dialog [modal]="true" [(visible)]="openTestEmailDialog" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-2">
            <i class="pi pi-flask text-2xl text-blue-600"></i>
            <span class="font-bold text-xl">Test Email Campaign</span>
        </div>
    </ng-template>
    <div class="flex flex-col gap-4 p-4">
        <div class="flex flex-col gap-2">
            <label for="testEmail" class="font-semibold text-gray-700">Email Address</label>
            <input id="testEmail" type="email" pInputText [(ngModel)]="testEmail" placeholder="Enter email address"
                class="w-full" />
            <small class="text-gray-500">Example: test&#64;example.com</small>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" [text]="true"
                (onClick)="openTestEmailDialog = false; testEmail = ''">
            </p-button>
            <p-button label="Send Test" icon="pi pi-send" [loading]="btnLoading" (onClick)="testEmailCampaign()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Email Campaign Report Dialog -->
<p-dialog [modal]="true" [(visible)]="isEmailReportDialogOpen" [breakpoints]="{ '1199px': '90vw', '575px': '95vw' }"
    closable="false" [style]="{ width: '90vw', height: '90vh' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isEmailReportDialogOpen">
        <app-email-report [campaignId]="editData.id" [campaignName]="editData.campaign_name"
            (closeDialog)="isEmailReportDialogOpen = false">
        </app-email-report>
    </div>
</p-dialog>

<!-- WhatsApp Campaign Report Dialog -->
<p-dialog [modal]="true" [(visible)]="isWhatsappReportDialogOpen" [breakpoints]="{ '1199px': '90vw', '575px': '95vw' }"
    closable="false" [style]="{ width: '90vw', height: '90vh' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isWhatsappReportDialogOpen">
        <app-whatsapp-report [campaignId]="editData.id" [campaignName]="editData.campaign_name"
            (closeDialog)="isWhatsappReportDialogOpen = false">
        </app-whatsapp-report>
    </div>
</p-dialog>

<p-confirmDialog key="emailConfigSteps" #cd [style]="{'max-width': '60vw', 'width': '60vw'}"
    styleClass="custom-confirm-dialog" appendTo="body">
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
            <div
                class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
                <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
            </div>
            <div class="mt-16 text-center w-full">
                <h3 class="text-2xl font-bold text-gray-900 mb-3">
                    {{ message.header }}
                </h3>
                <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
                    {{ message.message }}
                </p>
                <div *ngIf="message.key === 'emailConfigSteps'"
                    class="text-left bg-gray-50 rounded-lg p-5 mx-auto max-w-xl mb-6">
                    <div class="space-y-3">
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                1</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Connect Your Domain</p>
                                <p class="text-sm text-gray-600 -mt-1">Navigate to Configuration Panel and connect your
                                    domain.</p>
                            </div>
                        </div>
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                2</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Create Email Address</p>
                                <p class="text-sm text-gray-600">Create a dedicated email address (e.g.,
                                    marketing&#64;gravitas.ai) for sending marketing campaigns.</p>
                            </div>
                        </div>
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                3</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Map Email in Module Settings</p>
                                <p class="text-sm text-gray-600">Go to Module Mapping section and assign the email to
                                    send marketing campaigns.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center gap-3 mt-6">
                    <button *ngIf="message.rejectVisible !== false" pButton type="button"
                        [label]="message.rejectLabel || 'Cancel'" (click)="message.reject && message.reject()"
                        class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
                    </button>
                    <button pButton type="button" [label]="message.acceptLabel || 'Yes, Continue'"
                        (click)="message.accept && message.accept()"
                        class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

<p-confirmDialog key="whatsappConfigSteps" #cd [style]="{'max-width': '60vw', 'width': '60vw'}"
    styleClass="custom-confirm-dialog" appendTo="body">
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
            <div
                class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-lg animate-bounce-in">
                <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
            </div>
            <div class="mt-16 text-center w-full">
                <h3 class="text-2xl font-bold text-gray-900 mb-3">
                    {{ message.header }}
                </h3>
                <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
                    {{ message.message }}
                </p>
                <div class="text-left bg-gray-50 rounded-lg p-5 mx-auto max-w-xl mb-6">
                    <div class="space-y-3">
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                1</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Navigate to Configuration Panel</p>
                                <p class="text-sm text-gray-600 -mt-1">Go to Settings > Configuration Panel.</p>
                            </div>
                        </div>
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                2</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Enter WhatsApp Details</p>
                                <p class="text-sm text-gray-600">Fill in your WhatsApp Business API credentials (Email,
                                    API Key, App Name, Source).</p>
                            </div>
                        </div>
                        <div class="flex items-start gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center font-semibold flex-shrink-0">
                                3</div>
                            <div class="pt-1">
                                <p class="font-semibold text-gray-900">Save Configuration</p>
                                <p class="text-sm text-gray-600">Click Save to activate WhatsApp messaging capabilities.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center gap-3 mt-6">
                    <button *ngIf="message.rejectVisible !== false" pButton type="button"
                        [label]="message.rejectLabel || 'Cancel'" (click)="message.reject && message.reject()"
                        class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
                    </button>
                    <button pButton type="button" [label]="message.acceptLabel || 'Yes, Continue'"
                        (click)="message.accept && message.accept()"
                        class="px-8 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:-translate-y-0.5">
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>